<template>
  <div>
    <nav class="secondary-nav">
      <ul>
        <li :class="{ active: isActive('categories') }">
          <a
            href="#categories"
            @click="active = 'categories'"
            v-text="'Categories'"
          />
        </li>
        <li :class="{ active: isActive('posts') }">
          <a
            href="#posts"
            @click="active = 'posts'"
            v-text="'Posts'"
          />
        </li>
      </ul>
    </nav>
    <div class="p-8">
      <PostArchive v-if="isActive('posts')" />
      <CategoryArchive v-if="isActive('categories')" />
    </div>
  </div>
</template>

<script type="text/babel">
import PostArchive from './DiscussionPostArchive'
import CategoryArchive from './DiscussionCategoryArchive'

export default {
  name: 'DiscussionArchive',
  components: {
    PostArchive,
    CategoryArchive,
  },
  data() {
    return {
      active: null,
    }
  },
  mounted() {
    this.active = this.getAnchor() === 'posts' ? 'posts' : 'categories'
  },
  methods: {
    getAnchor() {
      return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null
    },
    isActive(type) {
      return this.active === type
    },
  },
}
</script>
